import { useState } from 'react';
import DeleteConfirmationModal from './deleteConfirmationModal';

const GridOptionButton = ({
  handleOpenEditForm,
  paramsValue,
  rowData,
  handleClickDelete,
  handleOpenViewForm,
  hasDeleteContactPermission,
  hasUpdateContactPermission,
  hasInfoContactPermission,
}) => {
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleDeleteClick = () => {
    setShowConfirmation(true);
  };

  const handleConfirmDelete = () => {
    handleClickDelete(paramsValue);
    setShowConfirmation(false);
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
  };

  return (
    <div className="action-menu">
      {hasUpdateContactPermission && (
        <img
          src="/assets/images/edit.png"
          className="action-img1"
          onClick={() => handleOpenEditForm(paramsValue)}
          alt="Edit Contact"
          title="Edit Contact"
        ></img>
      )}
      {hasInfoContactPermission && (
        <img
          src="/assets/images/view.png"
          className="action-img2"
          onClick={() => handleOpenViewForm(paramsValue)}
          alt="View Contact"
          title="View Contact"
        ></img>
      )}
      {hasDeleteContactPermission && (
        <img
          src="/assets/images/trash.png"
          className="action-img2"
          onClick={handleDeleteClick}
          alt="Delete Contact"
          title="Delete Contact"
        ></img>
      )}
      <DeleteConfirmationModal
        show={showConfirmation}
        handleClose={handleCloseConfirmation}
        handleConfirm={handleConfirmDelete}
        rowData={rowData}
      />
    </div>
  );
};

export default GridOptionButton;
